/** @returns {string} */
export const selectLocationPath = state => state.status.get('path')

/** @returns {200 | 404} */
export const selectLocationStatus = state => state.status.get('status')
